import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import o from "../Color.js";
import { JSONSupport as e } from "../core/JSONSupport.js";
import { clone as t } from "../core/lang.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as l } from "../core/accessorSupport/decorators/enumeration.js";
import { reader as p } from "../core/accessorSupport/decorators/reader.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
import { writer as c } from "../core/accessorSupport/decorators/writer.js";

var _a;

var n = _a = /*#__PURE__*/function (_e) {
  _inherits(a, _e);

  var _super = _createSuper(a);

  function a(r) {
    var _this;

    _classCallCheck(this, a);

    _this = _super.call(this, r), _this.placement = "begin-end", _this.type = "line-marker", _this.style = "arrow";
    return _this;
  }

  _createClass(a, [{
    key: "writeStyle",
    value: function writeStyle(r, o, e, t) {
      "web-map" === (null == t ? void 0 : t.origin) ? o[e] = "arrow" : o[e] = r;
    }
  }, {
    key: "color",
    set: function set(r) {
      this._set("color", r);
    }
  }, {
    key: "readColor",
    value: function readColor(r) {
      return r && null != r[0] ? [r[0], r[1], r[2], r[3] / 255] : r;
    }
  }, {
    key: "writeColor",
    value: function writeColor(r, o, e, t) {
      "web-map" === (null == t ? void 0 : t.origin) || (o[e] = r);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _a({
        color: t(this.color),
        placement: this.placement,
        style: this.style
      });
    }
  }, {
    key: "hash",
    value: function hash() {
      var r;
      return "".concat(this.placement, ".").concat(null == (r = this.color) ? void 0 : r.hash(), ".").concat(this.style);
    }
  }]);

  return a;
}(e);

r([s({
  type: ["begin", "end", "begin-end"],
  json: {
    write: !0
  }
})], n.prototype, "placement", void 0), r([l({
  "line-marker": "line-marker"
}, {
  readOnly: !0
}), s({
  json: {
    origins: {
      "web-map": {
        write: !1
      }
    }
  }
})], n.prototype, "type", void 0), r([s({
  type: ["arrow", "circle", "square", "diamond", "cross", "x"]
})], n.prototype, "style", void 0), r([c("style")], n.prototype, "writeStyle", null), r([s({
  type: o,
  value: null,
  json: {
    write: {
      allowNull: !0
    }
  }
})], n.prototype, "color", null), r([p("color")], n.prototype, "readColor", null), r([c("color")], n.prototype, "writeColor", null), n = _a = r([i("esri.symbols.LineSymbolMarker")], n);
var m = n;
export { m as default };